export default __webpack_public_path__ + "media/front-mobile.jpg";